import React from 'react'
import { Box, Flex, Image, Heading, Text, HStack, IconButton, chakra,Link } from '@chakra-ui/react';
import { FaGithub, FaNetlify } from 'react-icons/fa';
import { FiExternalLink } from 'react-icons/fi' 
import cityshop from "../images/City_Shop.png"
import flipkart from "../images/flipkart.png"
import fintech from "../images/FinTech.png"
import studyverse from "../images/studyverse.png"
import github from "../images/githublogo.png"
import deployed from "../images/netlify.png"

const projectData = [
  {
    imageSrc:fintech ,
    title: "FinService",
    description: "This is a web application that provides a user-friendly trading platform for investors to invest money in various companies. It is a user-friendly trading app website.",
    techStack: "HTML | CSS | JavaScript | React.js | Redux | Tailwind CSS | Node.js | Express | MongoDB",
    githubLink: "https://github.com/kkalyankumar9/gorgeous-hole-2479",
    deployedLink: "https://fin-serviceap-git-main-kalyankumars-projects.vercel.app/"
  },
  {
    imageSrc: cityshop,
    title: "City Shop",
    description: "Cloning Sparkel: It is a web application that provides a platform for fashion product purchases online. It is a user-friendly e-commerce website.",
    techStack: "HTML | CSS | JavaScript | React | TypeScript | Redux | Chakra UI",
    githubLink: "https://github.com/Rinkesh375/flying-word-4664",
    deployedLink: "https://shop-now-eight.vercel.app/"
  },

  {
    imageSrc:studyverse ,
    title: "StudyVerse",
    description: "StudyVerse is a web application that provides a platform to enhance students' learning online",
    techStack: "HTML | CSS | JavaScript | React | TypeScript | Redux | Chakra UI| node.js | express | mongoDB",
    githubLink: "https://github.com/RanjeetRaj444/festive-crayon-1023",
    deployedLink: "https://taupe-truffle-988056.netlify.app/"
  },
  {
    imageSrc: flipkart,
    title: "Flipkart",
    description: "Cloning Flipkart: It is a web application that provides a platform for shopping online. It is a user-friendly e-commerce website.",
    techStack: "HTML | CSS | JavaScript",
    githubLink: "https://github.com/kkalyankumar9/-brainy-deer-5360",
    deployedLink: "https://spiffy-tiramisu-b0a1c8.netlify.app/"
  }


];
const Projects = () => {
  return (
    <div  id="projects" className="project-card" >
     <Box  mx={"auto"} pt={5} px={{ base: 2, sm: 12, md: 17 }} >
        <chakra.h1
          textAlign={"center"}
          fontSize={"4xl"}
          py={10}
          fontWeight={"bold"}>
         Projects
        </chakra.h1>
      <Flex direction="column" align="center" p={4}>
        <Box className="project-container" w="100%" maxWidth="1200px">
          <Flex flexWrap="wrap"justify="center" gap={4}>
            {projectData.map((project, index) => (
              <Box key={index} className="project-card"   boxShadow="md" borderRadius="md" p={4} width="80%"  _hover={{
                bg: 'teal.400',
              }}>
                <Flex direction={{ base: 'column', md: 'row' }} justify="space-between" alignItems={"center"}>
                  <Box mb={{ base: 4, md: 0 }} w={"100%"}>
                    <Image src={project.imageSrc} alt={project.title} width="100%" maxW="500px" borderRadius="md" />
                  </Box>
                  <Box className="project-layer" p={4} width="100%">
                    <Heading as="h4" size="md" fontWeight="semibold" mb={2} className="project-title">
                      {project.title}
                    </Heading>
                    <Text color="gray.600" mb={2} className="project-description">
                      {project.description}
                    </Text>
                    <Text fontWeight="semibold" mb={2}  className="project-tech-stack">
                      {project.techStack}
                    </Text>
                    <HStack spacing={2} justify={"space-evenly"} >
                      <Link href={project.githubLink} isExternal className="project-github-link">
                        <Image w="30px" src={github} alt="GitHub" />
                      </Link>
                      <Link href={project.deployedLink} isExternal className="project-deployed-link">
                        <Image w="30px" src={deployed} alt="Deployed" />
                      </Link>
                    </HStack>
                  </Box>
                </Flex>
              </Box>
            ))}
          </Flex>
        </Box>
      </Flex>
    </Box>
    </div>
  )
}

export default Projects